document.addEventListener("DOMContentLoaded", () => {
  ["subjects", "courses"].forEach((item) => {
    const link = document.querySelector<HTMLAnchorElement>(`#${item}-link`);
    const dropdown = document.querySelector(`#${item}-dropdown`);

    if (!link || !dropdown) return;

    // Hover behavior to open the dropdown
    link.addEventListener("mouseenter", () => {
      link.setAttribute("aria-expanded", "true");
      dropdown.classList.add("show");
    });

    dropdown.addEventListener("mouseenter", () => {
      link.setAttribute("aria-expanded", "true");
      dropdown.classList.add("show");
    });

    // Hover behavior to close the dropdown
    link.addEventListener("mouseleave", () => {
      setTimeout(() => {
        if (!dropdown.matches(":hover")) {
          link.setAttribute("aria-expanded", "false");
          dropdown.classList.remove("show");
        }
      }, 200); // Slight delay for smoother transitions
    });

    dropdown.addEventListener("mouseleave", () => {
      setTimeout(() => {
        if (!link.matches(":hover")) {
          link.setAttribute("aria-expanded", "false");
          dropdown.classList.remove("show");
        }
      }, 200);
    });
  });
});
